/****************************************************
 * Module Name:  viewPricePlanModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useEffect, useState } from "react";
import { Box, Tooltip, } from "@mui/material";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";
import EditIcon from '@mui/icons-material/Edit';
import Constants from "../../../utility/constants";
import Utility from "../../../utility/utility";
import renderCellExpand from "../../common/dataGridCellExpand";
import TenderLotBidProxy from "../../../utility/proxy/manager/tender/tenderLotBidProxy";
import CommonSnackbar from "../../common/commonSnackBar";
import logo from '../../../images/pansuriya.jpg'
import { Modal } from "react-bootstrap";

const ViewPricePlanModal = ({
    tenderStoneId, tenderLotId, show, handleClose
}) => {
    const [listData, setListData] = useState([]);
    const [filterValues, setFilterValues] = useState({});
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarVariant, setSnackbarVariant] = useState("");
    const [outerLoader, setOuterLoader] = useState();

    useEffect(() => {
        handleSearch();
    }, []);

    const handleSearch = () => {
        setOuterLoader(true);
        TenderLotBidProxy.GetTenderPlansByStoneID(tenderStoneId, tenderLotId, (response) => {
            setOuterLoader(true);
            if (response) {
                const responseData = response.map(item => ({
                    ...item,
                    stonetype: item.stonetype === "L" ? "Lab Grown Diamonds" : "Natural Diamonds",
                    rapnetprice: item.currentrapnetprice,

                }));

                const uniqueFilterValues = {
                    createdbyusername: Utility.getDistinctOptions(responseData, "createdbyusername"),
                    shape: Utility.getDistinctOptions(responseData, "shape"),
                    color: Utility.getDistinctOptions(responseData, "color"),
                    cut: Utility.getDistinctOptions(responseData, "cut"),
                    pol: Utility.getDistinctOptions(responseData, "pol"),
                    sym: Utility.getDistinctOptions(responseData, "sym"),
                    clarity: Utility.getDistinctOptions(responseData, "clarity"),
                    flo: Utility.getDistinctOptions(responseData, "flo"),
                    stonetype: Utility.getDistinctOptions(responseData, "stonetype"),
                    lockedbyusername: Utility.getDistinctOptions(responseData, "lockedbyusername"),
                    status: Utility.getDistinctOptions(responseData, "status"),
                    lab: Utility.getDistinctOptions(responseData, "lab"),
                    colortype: Utility.getDistinctOptions(responseData, "colortype"),
                    fancycolor1: Utility.getDistinctOptions(responseData, "fancycolor1"),
                    fancycolor2: Utility.getDistinctOptions(responseData, "fancycolor2"),
                    fromintensity: Utility.getDistinctOptions(responseData, "fromintensity"),
                    tointensity: Utility.getDistinctOptions(responseData, "tointensity"),
                    overtone: Utility.getDistinctOptions(responseData, "overtone"),
                };

                setFilterValues(uniqueFilterValues);
                setOuterLoader(false);
                setListData(responseData);
            } else {
                setOuterLoader(false);
                setShowSnackbar(true);
                setSnackbarMessage(Constants.APiFailErrorMessage);
                setSnackbarVariant("error");
            }
        })
    }

    const outerColumns = [
        {
            field: 'id',
            headerName: 'ID',
            headerAlign: 'center',
            align: 'center',
            type: 'number',
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
            width: 50
        },
        {
            field: 'planid',
            headerName: 'PLAN ID',
            headerAlign: 'center',
            align: 'center',
            type: 'number',
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
            width: 80
        },
        {
            field: 'shape',
            headerName: 'SHAPE',
            headerAlign: 'center',
            align: 'center',
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.shape : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
            width: 123,
        },
        {
            field: 'size',
            headerName: 'CTS',
            headerAlign: 'center',
            align: 'center',
            type: 'number',
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
            width: 76
        },
        {
            field: 'colortype',
            headerName: 'COL TYPE',
            headerAlign: 'center',
            align: 'center',
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.colortype : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
            width: 80
        },
        {
            field: 'color',
            headerName: 'COL',
            headerAlign: 'center',
            align: 'center',
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.color : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
            width: 30
        },
        {
            field: 'fancycolor1',
            headerName: 'FANCY COLOR 1',
            headerAlign: 'center',
            align: 'center',
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.fancycolor1 : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
            width: 115
        },
        {
            field: 'fancycolor2',
            headerName: 'FANCY COLOR 2',
            headerAlign: 'center',
            align: 'center',
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.fancycolor2 : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
            width: 115
        },
        {
            field: 'fromintensity',
            headerName: 'FROM INTENSITY',
            headerAlign: 'center',
            align: 'center',
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.fromintensity : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
            width: 125
        },
        {
            field: 'tointensity',
            headerName: 'TO INTENSITY',
            headerAlign: 'center',
            align: 'center',
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.tointensity : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
            width: 100
        },
        {
            field: 'overtone',
            headerName: 'OVERTONE',
            headerAlign: 'center',
            align: 'center',
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.overtone : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
            width: 90
        },
        {
            field: 'clarity',
            headerName: 'CLR',
            headerAlign: 'center',
            align: 'center',
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.clarity : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
            width: 60
        },
        {
            field: 'cut',
            headerName: 'CUT',
            headerAlign: 'center',
            align: 'center',
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.cut : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
            width: 40
        },
        {
            field: 'pol',
            headerName: 'POL',
            headerAlign: 'center',
            align: 'center',
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.pol : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
            width: 40
        },
        {
            field: 'sym',
            headerName: 'SYM',
            headerAlign: 'center',
            align: 'center',
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.sym : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
            width: 40
        },
        {
            field: 'flo',
            headerName: 'FLO',
            headerAlign: 'center',
            align: 'center',
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.flo : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
            width: 60
        },
        {
            field: 'lab',
            headerName: 'LAB',
            headerAlign: 'center',
            align: 'center',
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.lab : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
            width: 50
        },
        {
            field: 'stonetype',
            headerName: 'STONE TYPE',
            headerAlign: 'center',
            align: 'center',
            type: "singleSelect",
            valueGetter: (params) => params.value,
            valueOptions: filterValues ? filterValues.stonetype : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: (params) => params.value,
            width: 130
        },
        {
            field: 'noofstones',
            headerName: 'STONES',
            headerAlign: 'center',
            align: 'center',
            type: 'number',
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
            width: 75,
            renderHeader: () => (
                <Tooltip title="NO. OF STONES" placement="bottom">
                    <span>STONES</span>
                </Tooltip>
            ),
        },
        {
            field: 'discount',
            headerName: 'DIS',
            headerAlign: 'center',
            align: 'center',
            type: 'number',
            width: 80,
            editable: true,
            valueFormatter: (params) => params.value,
            renderCell: (params) => params.row.colortype === "WHITE" ? (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: '5px', marginLeft: '10px' }}>
                        {params.value !== undefined && params.value !== null ?
                            parseFloat(params.value).toFixed(Constants.DEFAULT_NO_OF_DIGITS) : '0.00'}
                    </span>
                    {params.colDef.editable && <EditIcon style={{ marginLeft: 3, marginBottom: 3, fontSize: '1rem' }} />}
                </div>
            ) : (params.value ? (params.value).toFixed(2) : '0.00'),
            cellClassName: (params) => params.row.colortype === "WHITE" ? 'lavenderCell' : 'cursorNA'
        },
        {
            field: 'rapnetprice',
            headerName: 'RAP',
            headerAlign: 'center',
            align: 'center',
            type: 'number',
            valueFormatter: (params) => params.value,
            width: 60
        },
        {
            field: 'ppc',
            headerName: 'PPC',
            headerAlign: 'center',
            align: 'right',
            type: 'number',
            editable: true,
            width: 110,
            valueFormatter: (params) => params.value,
            renderCell: (params) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: '5px', marginLeft: '10px' }}>
                        {params.value !== undefined && params.value !== null
                            ? parseFloat(params.value).toFixed(Constants.DEFAULT_NO_OF_DIGITS)
                            : params.value}
                    </span>
                    {params.colDef.editable && <EditIcon style={{ marginLeft: 3, marginBottom: 3, fontSize: '1rem' }} />}
                </div>
            ),
            cellClassName: (params) => 'lavenderCell'
        },
        {
            field: 'labprice',
            headerName: 'LAB $',
            headerAlign: 'center',
            align: 'center',
            type: 'number',
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
            width: 40
        },
        {
            field: 'stoneprice',
            headerName: 'STONE $',
            headerAlign: 'center',
            align: 'center',
            type: 'number',
            valueFormatter: (params) => params.value,
            width: 80,
            renderHeader: () => (
                <Tooltip title="PPC * CTS" placement="bottom">
                    <span>STONE $</span>
                </Tooltip>
            ),
        },
        {
            field: 'total',
            headerName: 'TOTAL $',
            headerAlign: 'center',
            align: 'right',
            type: 'number',
            width: 110,
            editable: true,
            valueFormatter: (params) => params.value,
            renderHeader: () => (
                <Tooltip title="STONE $ - LAB $" placement="bottom">
                    <span>TOTAL $</span>
                </Tooltip>
            ),
            renderCell: (params) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: '5px', marginLeft: '10px' }}>
                        {params.value !== undefined && params.value !== null
                            ? parseFloat(params.value).toFixed(Constants.DEFAULT_NO_OF_DIGITS)
                            : params.value}
                    </span>
                    {params.colDef.editable && <EditIcon style={{ marginLeft: 3, marginBottom: 3, fontSize: '1rem' }} />}
                </div>
            ),
            cellClassName: (params) => 'lavenderCell'
        },
        {
            field: 'finaltotal',
            headerName: 'FINAL $',
            headerAlign: 'center',
            align: 'center',
            type: 'number',
            valueFormatter: (params) => params.value,
            renderCell: (params) => Number(params.row.total * params.row.noofstones).toFixed(Constants.DEFAULT_NO_OF_DIGITS) || "",
            width: 75,
            renderHeader: () => (
                <Tooltip title="TOTAL $ * NO. OF STONES" placement="bottom">
                    <span>FINAL $</span>
                </Tooltip>
            ),
        },
        {
            field: 'createdby',
            headerName: 'CREATED BY',
            headerAlign: 'center',
            align: 'center',
            type: 'number',
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
            width: 92
        },
        {
            field: 'createdbyusername',
            headerName: 'CREATED BY USERNAME',
            headerAlign: 'center',
            align: 'center',
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.createdbyusername : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
            width: 150
        },
        {
            field: 'createdat',
            headerName: 'CREATED AT',
            headerAlign: 'center',
            align: 'center',
            type: "date",
            valueGetter: (params) => {
                if (params.value) {
                    return new Date(params.value);
                }
                return null;
            },
            renderCell: (params) => {
                if (params.value) {
                    return Utility.ConvertUtcToLocalDate(params.value);
                } else {
                    return "";
                }
            },
            width: 150
        },
        {
            field: 'updatedat',
            headerName: 'UPDATED AT',
            headerAlign: 'center',
            align: 'center',
            width: 150,
            type: "date",
            valueGetter: (params) => {
                if (params.value) {
                    return new Date(params.value);
                }
                return null;
            },
            renderCell: (params) => {
                if (params.value) {
                    return Utility.ConvertUtcToLocalDate(params.value);
                } else {
                    return "";
                }
            }
        },
        {
            field: 'status',
            headerName: 'STATUS',
            headerAlign: 'center',
            align: 'center',
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.status : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
            width: 100
        },
        {
            field: 'iscertified',
            headerName: 'IS CERTIFIED',
            headerAlign: 'center',
            align: 'center',
            type: "boolean",
            width: 100
        },

    ];

    return (
        <div>
            <div>
                <CommonSnackbar
                    show={showSnackbar}
                    message={snackbarMessage}
                    variant={snackbarVariant}
                    autoHide={Constants.SnackBarCloseTimer}
                    title={snackbarVariant === "success" ? "Success" :
                        (snackbarVariant === "error" ? "Failed" : "Warning")}
                    handleClose={() => setShowSnackbar(false)}
                />

                <Modal backdrop="static" show={show} onHide={handleClose} enforceFocus={false}
                    dialogClassName="max-modalSize-med">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <img
                                src={logo}
                                height="40pt"
                                width="40pt"
                                alt={Constants.COMPANY_SITE}
                            />
                            &nbsp;&nbsp;
                            Plans
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Box
                            sx={{
                                px: 1,
                                width: "100%",
                                position: "relative",
                                backgroundColor: '#fff',
                                color: '#000',
                                "& .MuiTablePagination-selectLabel": {
                                    marginTop: "15px",
                                },
                                "& .MuiTablePagination-displayedRows": {
                                    marginTop: "15px",
                                },
                                "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                                    fontWeight: Constants.defaultFontWeight,
                                },
                                "& .css-1knaqv7-MuiButtonBase-root-MuiButton-root": {
                                    color: "#1976d2",
                                    padding: "4px 5px",
                                    borderRadius: "4px",
                                },
                                "& .css-znmrd6-MuiButtonBase-root-MuiButton-root": {
                                    color: "#1976d2",
                                    padding: "5px 5px",
                                    borderRadius: "4px",
                                },
                                "& .css-cc8tf1": {
                                    fontWeight: Constants.defaultFontWeight,
                                },
                                height: "75vh",
                            }}
                        >
                            <DataGridPro
                                sx={{
                                    '& .MuiDataGrid-columnHeader': {
                                        color: '#fff',
                                        backgroundColor: 'grey',
                                        fontWeight: Constants.defaultFontWeight,
                                    },
                                    "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                                        py: "6px",
                                    },
                                    "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                                        py: "12px",
                                    },
                                    "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                                        py: "18px",
                                    },

                                    "& .lavenderCell": {
                                        color: "#080808",
                                        backgroundColor: "#D8BFD8",
                                    },
                                    "& .cursorNA": {
                                        pointerEvents: "none !important",
                                    },
                                    "& .darkBlueCell": {
                                        color: "#080808",
                                        backgroundColor: "#A1E3F9",
                                    },
                                    fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
                                }}
                                density="compact"
                                disableRowSelectionOnClick={true}
                                slots={{ toolbar: GridToolbar }}
                                rows={listData}
                                columns={outerColumns}
                                getRowId={(row) => row.id}
                                loading={outerLoader}
                                initialState={{
                                    columns: {
                                        columnVisibilityModel: {
                                            // Hide columns id, the other columns will remain visible
                                        },
                                    },
                                    pagination: {
                                        paginationModel: Constants.pageSize,
                                    },
                                }}
                                pageSizeOptions={Constants.pageSizeOptions}
                                pagination
                                slotProps={{
                                    toolbar: {
                                        showQuickFilter: true,
                                        quickFilterProps: {
                                            debounceMs: 500,
                                        },
                                    },
                                }}
                            />
                            <Box
                                style={{
                                    position: "absolute",
                                    top: 5,
                                    right: "270px",
                                }}
                            >
                                {outerLoader ? (
                                    <CircularProgress size="1rem" />
                                ) : (
                                    <Tooltip title="Reload List">
                                        <RefreshOutlinedIcon
                                            onClick={() => handleSearch()}
                                            color="primary"
                                            loading={outerLoader}
                                            fontSize="medium"
                                            sx={{ cursor: "pointer", mr: 1 }}
                                        />
                                    </Tooltip>
                                )}
                            </Box>
                        </Box>
                    </Modal.Body>
                </Modal>
            </div>
        </div>

    );
}

export default ViewPricePlanModal;